import { VerifyPhoneNumberSuccessType } from '../../../__generated__/globalTypes'

import { AccountFragment, isAccountFragment } from './AccountFragment'

import verifyPhoneNumberSuccessFragmentRawString from '../VerifyPhoneNumberSuccessFragment.graphql'

export const verifyPhoneNumberSuccessFragmentString = verifyPhoneNumberSuccessFragmentRawString

export type VerifyPhoneNumberSuccessFragment = {
  successType: VerifyPhoneNumberSuccessType
  verifiedAccount: AccountFragment
}

export const isVerifyPhoneNumberSuccessFragment = (
  fragment: any,
): fragment is VerifyPhoneNumberSuccessFragment =>
  fragment &&
  (fragment.successType === 'SIGNED_INTO_EXISTING_ACCOUNT' ||
    fragment.successType === 'CREATED_NEW_ACCOUNT' ||
    fragment.successType === 'UPDATED_EXISTING_ACCOUNT') &&
  (isAccountFragment(fragment.verifiedAccount) as boolean)
